/* Клиент API «Шаблоны»: сохранённые ответы с текстом (подстановки $contact.*, $user.*) и файлами; в диалоге вызываются по «/ключ».
   Правят владелец, администраторы и менеджеры; продавцы только используют. */
import { api, apiUrl } from "@/lib/api";

export type SnippetFile = { id: string; name: string; mime: string; size: number; url: string };
export type Snippet = { id: string; key: string; name: string; message: string; topic: string; files: SnippetFile[]; createdAt: string; updatedAt: string };

export type SnippetIn = Partial<{ key: string; name: string; message: string; topic: string; files: string[] }>;

export const snippetsApi = {
  list: () => api<{ items: Snippet[]; canEdit: boolean; topics: string[] }>("/snippets"),
  create: (body: SnippetIn) => api<Snippet>("/snippets", { method: "POST", json: body }),
  update: (id: string, body: SnippetIn) => api<Snippet>(`/snippets/${id}`, { method: "PATCH", json: body }),
  remove: (id: string) => api(`/snippets/${id}`, { method: "DELETE" }),
  upload: (file: File) => {
    const fd = new FormData();
    fd.append("file", file, file.name);
    return api<{ id: string; name: string; mime: string; size: number }>("/snippets/files", { method: "POST", body: fd });
  },
};

export const snippetFileUrl = (f: SnippetFile) => apiUrl(f.url.replace(/^\/api/, ""));

/** Подстановки для предпросмотра в поле ответа (сервер делает то же при отправке). */
export function fillVars(text: string, contact: { name?: string; phone?: string | null; email?: string | null; company?: string } | null, user: { name: string; email: string } | null): string {
  const first = (contact?.name ?? "").split(" ")[0] ?? "";
  const last = (contact?.name ?? "").split(" ").slice(1).join(" ");
  const vals: Record<string, string> = {
    "contact.firstName": first,
    "contact.lastName": last,
    "contact.name": contact?.name ?? "",
    "contact.phone": contact?.phone ?? "",
    "contact.email": contact?.email ?? "",
    "contact.company": contact?.company ?? "",
    "user.name": user?.name ?? "",
    "user.firstName": (user?.name ?? "").split(" ")[0] ?? "",
    "user.email": user?.email ?? "",
  };
  return text.replace(/\$(contact|user)\.(firstName|lastName|name|phone|email|company)\b/g, (_, a: string, b: string) => vals[`${a}.${b}`] ?? "");
}
